import React from 'react';

export const STATUS_409 = 409;

export const ERROR_CODE_319 = 319;
export const ERROR_CODE_325 = 325;
export const ERROR_CODE_326 = 326;

export const ERROR_CODES = {
  1036: content => error_1036(content),
  318: content => error_318(content),
  319: content => error_319(content),
  325: (websiteBaseDirectory, content) => error_325(websiteBaseDirectory, content),
  326: (websiteBaseDirectory, content) => error_326(websiteBaseDirectory, content),
  327: content => error_327(content)
};

const hyperlinkError318 = (link, content) => (
  <a target="_blank" rel="noopener noreferrer" href={link}>
    {' '}
    {content.createCaseErrorMessage_linkName_318}{' '}
  </a>
);

const error_1036 = content => <span>{content.createCaseErrorMessage_1036}</span>;

const error_318 = content => (
  <span>
    {content.createCaseErrorMessagePrefix_318}{' '}
    {hyperlinkError318(content.createCaseErrorHyperlink_318, content)}{' '}
    {content.createCaseErrorMessage_suffix}
  </span>
);

const error_319 = content => <span>{content.createCaseErrorMessage_linkName_319}</span>;

const hyperlinkError325 = (websiteBaseDirectory, content) => (
  <a target="_blank" rel="noopener noreferrer" href={`${websiteBaseDirectory}`}>
    {content.createCaseErrorMessage_linkName_325}
  </a>
);

const hyperlinkError326 = (websiteBaseDirectory, content) => (
  <a target="_blank" rel="noopener noreferrer" href={`${websiteBaseDirectory}`}>
    {content.createCaseErrorMessage_linkName_326}
  </a>
);

const error_325 = (websiteBaseDirectory, content) => (
  <span>
    {content.createCaseErrorMessagePrefix_326} {hyperlinkError325(websiteBaseDirectory, content)}{' '}
    {content.createCaseErrorMessage_suffix}
  </span>
);

const error_326 = (websiteBaseDirectory, content) => (
  <span>
    {content.createCaseErrorMessagePrefix_326} {hyperlinkError326(websiteBaseDirectory, content)}{' '}
    {content.createCaseErrorMessage_suffix}
  </span>
);

const error_327 = content => <span>{content.createCaseErrorMessage_327}</span>;
